import {
  getConduitGatewayEndpoint,
  getFrontendConfigServiceEndpoint,
  getPaymentApiEndpoint,
  getUserManagementEndpoint,
} from "./endpoints";
import { httpClientFactory } from "./httpClient/httpClientFactory";

export const createPaymentApiFetcher = httpClientFactory({
  name: "payment_api",
  getBaseURL: getPaymentApiEndpoint,
});

export const createUserManagementServiceFetcher = httpClientFactory({
  name: "user_management_service",
  getBaseURL: getUserManagementEndpoint,
});

export const createFrontendConfigurationServiceFetcher = httpClientFactory({
  name: "frontend_configuration_service",
  getBaseURL: getFrontendConfigServiceEndpoint,
});

export const createConduitGatewayFetcher = httpClientFactory({
  name: "conduit_gateway",
  getBaseURL: getConduitGatewayEndpoint,
});
